import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { calculateRem } from '@vds-core/utilities';
import UNSAFE_SetEnvRef from '@uie/set-env-ref';
import { AccessibilityTokens } from '@vds-tokens/accessibility';
import { checkIfMobileDevice } from '@vds-core/utilities';

// Use close-bold.svg
var CloseBoldIcon = /*#__PURE__*/React.createElement("svg", {
  version: "1.1",
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  x: "0px",
  y: "0px",
  viewBox: "0 0 21.6 21.6"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.2,10.8l6.8,6.8L17.6,19l-6.8-6.8L4,19l-1.4-1.4l6.8-6.8L2.6,4L4,2.6l6.8,6.8l6.8-6.8L19,4L12.2,10.8z"
}));

// Use close.svg
var CloseIcon = /*#__PURE__*/React.createElement("svg", {
  id: "Layer_1",
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21.6 21.6"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.59,10.8l7.11,7.1-.8.8-7.1-7.11L3.7,18.7l-.8-.8L10,10.8,2.9,3.7l.8-.8L10.8,10,17.9,2.9l.8.8Z"
}));
var propTypes = {
  /**
   * @ignore
   */
  controlFunc: PropTypes.func.isRequired,
  /**
   * @ignore
   */
  visible: PropTypes.bool.isRequired,
  /**
   * @ignore
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(['small', 'medium', 'large', 'XLarge']), PropTypes.string]),
  /**
   * @ignore
   */
  type: PropTypes.oneOf(['error', 'info', 'success', 'warning']),
  /**
   * @ignore
   */
  colorConfig: PropTypes.object,
  /**
   * @ignore
   */
  contentColor: PropTypes.string,
  /**
   * @ignore
   * determines the height of the close button
   */
  closeButtonHeight: PropTypes.string,
  /**
   * @ignore
   * focusRing border
   */
  focusringBorderRadius: PropTypes.string,
  /**
   * @ignore
   * Color for icon color when active
   */
  iconActiveColor: PropTypes.string,
  /**
   * @ignore
   * Color for focusring
   */
  focusringColor: PropTypes.string
};
var defaultProps = {
  size: 'small',
  //added after renaming
  type: 'success',
  closeButtonHeight: calculateRem(16)
};
var CloseButtonContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "CloseButtonContainer",
  componentId: "VDS__sc-4z0w5p-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  right: 0;\n"])));
var StyledButton = /*#__PURE__*/styled.button.withConfig({
  displayName: "StyledButton",
  componentId: "VDS__sc-4z0w5p-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  box-sizing: border-box;\n  background: transparent;\n  border: 0;\n  padding: 0;\n  outline: none;\n  ", "\n  &:hover {\n    cursor: pointer;\n  }\n  &:active,\n  &:hover,\n  &:visited {\n    outline: none;\n  }\n  &:active,\n  &.active {\n    svg {\n      path {\n        fill: ", ";\n      }\n    }\n  }\n  ", ";\n"])), function (_ref) {
  var closeButtonHeight = _ref.closeButtonHeight;
  return "\n    width: ".concat(closeButtonHeight, ";\n    height: ").concat(closeButtonHeight, ";\n  ");
}, function (_ref2) {
  var iconActiveColor = _ref2.iconActiveColor;
  return iconActiveColor;
}, function (_ref3) {
  var focused = _ref3.focused,
    keyboardFocused = _ref3.keyboardFocused,
    hovered = _ref3.hovered,
    focusringBorderRadius = _ref3.focusringBorderRadius,
    focusringColor = _ref3.focusringColor;
  return focused && keyboardFocused && !hovered && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      &:not(:active):not(:hover):not(.active) {\n        outline: none;\n        &::before {\n          border: ", "\n            ", " ", ";\n          border-radius: ", ";\n          content: '';\n          position: absolute;\n          pointer-events: none;\n          top: 50%;\n          left: 50%;\n          transform: translate(-50%, -50%);\n          width: 100%;\n          height: 100%;\n        }\n      }\n    "])), AccessibilityTokens.focusring.borderwidth.value, AccessibilityTokens.focusring.borderstyle.value, focusringColor, focusringBorderRadius);
});
var HitArea = /*#__PURE__*/styled.span.withConfig({
  displayName: "HitArea",
  componentId: "VDS__sc-4z0w5p-2"
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  cursor: pointer;\n  height: ", ";\n  width: ", ";\n  z-index: 1;\n  background-color: transparent;\n"])), calculateRem(48), calculateRem(48));
var IconSVGWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "IconSVGWrapper",
  componentId: "VDS__sc-4z0w5p-3"
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  height: ", ";\n  width: ", ";\n  min-height: ", ";\n  min-width: ", ";\n  ", ";\n  &:active,\n  &:focus {\n    outline: none;\n  }\n  svg {\n    path {\n      fill: ", ";\n    }\n  }\n"])), function (_ref4) {
  var iconSize = _ref4.iconSize;
  return iconSize;
}, function (_ref5) {
  var iconSize = _ref5.iconSize;
  return iconSize;
}, function (_ref6) {
  var iconSize = _ref6.iconSize;
  return iconSize;
}, function (_ref7) {
  var iconSize = _ref7.iconSize;
  return iconSize;
}, function (_ref8) {
  var tabIndex = _ref8.tabIndex;
  return tabIndex < 0 && "\n    outline: none;\n    pointer-events: none;\n  ";
}, function (_ref9) {
  var iconColor = _ref9.iconColor;
  return iconColor;
});

/**
 * @ignore
 */
var NotificationClose = /*#__PURE__*/function (_React$Component) {
  _inherits(NotificationClose, _React$Component);
  var _super = _createSuper(NotificationClose);
  function NotificationClose(props) {
    var _this;
    _classCallCheck(this, NotificationClose);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "refPath", UNSAFE_SetEnvRef());
    _defineProperty(_assertThisInitialized(_this), "isFirefox", function () {
      return typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    }());
    _defineProperty(_assertThisInitialized(_this), "_clickClose", function (e) {
      _this.props.controlFunc(e);
      /* istanbul ignore else  */
      if (e.type === 'click') e.currentTarget.blur();
    });
    _defineProperty(_assertThisInitialized(_this), "_toggleHover", function () {
      _this.setState({
        hovered: !_this.state.hovered
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_onFocus", function () {
      var disabled = _this.props.disabled;
      if (!disabled) {
        _this.setState({
          focused: true
        });
        if (!_this.state.hovered && !_this.state.keyboardFocused) {
          _this.setState({
            keyboardFocused: true
          });
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_onBlur", function () {
      _this.setState({
        focused: false,
        keyboardFocused: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_onMouseDown", function () {
      _this.state.keyboardFocused && _this.setState({
        keyboardFocused: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_onKeyUp", function (e) {
      var id = _this.props.id;
      // Manually remove custom class active for firefox
      if ((e.keyCode === 32 || e.keyCode === 13) && _this.isFirefox) {
        var btn = typeof document !== 'undefined' && document.getElementById(id).classList;
        btn.remove('active');
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_onKeyDown", function (e) {
      var id = _this.props.id;
      // Do this for firefox for active state because keying down doesn't trigger pseudoclass :active
      // So we add a custom class active then trigger the same effects for pseudoclas :active
      if ((e.keyCode === 32 || e.keyCode === 13) && _this.isFirefox) {
        var btn = typeof document !== 'undefined' && document.getElementById(id).classList;
        btn.add('active');
      }
    });
    _this.state = {
      hovered: false,
      focused: false
    };
    _this.closeRef = null;
    return _this;
  }
  _createClass(NotificationClose, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        colorConfig = _this$props.colorConfig,
        contentColor = _this$props.contentColor,
        visible = _this$props.visible,
        size = _this$props.size,
        closeButtonHeight = _this$props.closeButtonHeight,
        cta = _this$props.cta,
        level = _this$props.level,
        position = _this$props.position,
        dataTrack = _this$props.dataTrack,
        id = _this$props.id,
        surface = _this$props.surface,
        focusringBorderRadius = _this$props.focusringBorderRadius,
        iconActiveColor = _this$props.iconActiveColor,
        focusringColor = _this$props.focusringColor,
        isFirstFocus = _this$props.isFirstFocus;
      var _isMobileDevice = checkIfMobileDevice();
      var _renderIcons = function _renderIcons() {
        if (_this2.state.hovered) {
          return CloseBoldIcon;
        } else {
          return CloseIcon;
        }
      };
      var _getIconSize = function _getIconSize() {
        switch (size) {
          case 'small':
            return calculateRem(16);
          case 'medium':
            return calculateRem(20);
          case 'large':
            return calculateRem(24);
          case 'XLarge':
            return calculateRem(28);
          default:
            return size;
          // Since size accepts string so this could be 20% or 20px
        }
      };

      return /*#__PURE__*/React.createElement(CloseButtonContainer, null, /*#__PURE__*/React.createElement(StyledButton, _extends({
        closeButtonHeight: closeButtonHeight,
        onMouseEnter: this._toggleHover,
        onMouseLeave: this._toggleHover,
        colorConfig: colorConfig,
        focusringColor: focusringColor,
        onClick: this._clickClose,
        tabIndex: visible ? 0 : -1,
        focused: this.state.focused,
        keyboardFocused: this.state.keyboardFocused,
        hovered: this.state.hovered,
        onFocus: this._onFocus,
        onBlur: this._onBlur,
        onMouseDown: this._onMouseDown,
        id: id,
        "data-testid": "Notification-close-button",
        "aria-label": _isMobileDevice && isFirstFocus ? 'Notification Close button' : 'Notification Close' // Altering the order for notification to read the message first supressed the role button being read on mobile
        ,
        role: "button",
        "data-sitecat-level": level,
        "data-sitecat-cta": cta,
        "data-sitecat-datatrack": dataTrack,
        "data-sitecat-position": position,
        surface: surface,
        focusringBorderRadius: focusringBorderRadius,
        iconActiveColor: iconActiveColor,
        onKeyDown: this._onKeyDown,
        onKeyUp: this._onKeyUp
      }, _isMobileDevice && isFirstFocus && {
        'aria-live': 'polite'
      }, _defineProperty({}, this.refPath, function (elem) {
        return _this2.closeRef = elem;
      })), /*#__PURE__*/React.createElement(IconSVGWrapper, {
        "aria-hidden": true,
        iconSize: _getIconSize(),
        tabIndex: -1,
        iconColor: contentColor,
        "aria-label": this.state.hovered ? 'close-bold icon' : 'close icon'
      }, _renderIcons()), /*#__PURE__*/React.createElement(HitArea, null)));
    }
  }]);
  return NotificationClose;
}(React.Component);
NotificationClose.propTypes = propTypes;
NotificationClose.defaultProps = defaultProps;
export default NotificationClose;